const config = {
  apiBaseUrl: process.env.NODE_ENV === 'production'
    ?
    'https://nsyncapp-api-v2.uc.r.appspot.com/api'
    :
    'http://localhost:3001/api'
};


export default config;
